export const KnowledgeHubTabsEnum = {
  OVERVIEW: 0,
  FACTS: 1,
  TRAIN_PROGRESS: 2,
  USERS: 3,
  SUGGESTIONS: 4,
  ACTIVITY_LOG: 5,
};

export default KnowledgeHubTabsEnum;

